import React, { useContext, useState, useEffect } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  GraficoPocoStyled,
  CalendarioBombaStyled,
} from "../../Styles/GraficoPoco";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { CiCalendar } from "react-icons/ci";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ElevatoriaContext } from "../../Context/contextElevatoria";
import {
  ModalCalenderBomba,
  ModalCalenderPoco,
} from "../../Styles/GraficoPoco";
import { apiSae } from "../../services/api";
import { formatInTimeZone } from "date-fns-tz";
import { HomeContext } from "../../Context/ContextHome";
import { format } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const GraficoPoco = (pros) => {
  const { idPoco, altura } = pros;
  const { modalIsOpen, setModalIsOpen, selectedDate, setIdDataPoco, dataPoco } =
    useContext(ElevatoriaContext);
  const { socket, darkMode } = useContext(HomeContext);

  const [listGrafico, setListGrafico] = useState([]);
  const [numeroCalendario, setNumeroCalendario] = useState("");
  const [pocoCalender, setPocoCalender] = useState("");

  const ListarData = (data) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const response = data.toLocaleDateString("pt-BR", options);
    setNumeroCalendario(response);
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm:ss");
  };

  const renderData = async (data) => {
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");

    const token = localStorage.getItem("tokenBrk");

    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      ListarData(data);
      setPocoCalender(data);
      const response = await apiSae.get(
        `historico/poco/data/${idPoco}/${day}-${month}-${year}`,
        headerApi
      );
      setListGrafico(response.data);
    } catch (error) {
      setListGrafico([]);
    }
  };

  useEffect(() => {
    renderData(selectedDate);
  }, [idPoco]);

  const Dados = {
    labels: listGrafico.map((label) => formatTime(label.timestamp)),
    datasets: [
      {
        label: `Nível do Poço`,
        data: listGrafico.map((data) => data.nivel_atual),
        backgroundColor: "#60ABFF",
      },
    ],
  };

  useEffect(() => {
    if (modalIsOpen) {
      document.body.classList.add("modal-open"); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove("modal-open"); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalIsOpen]);

  const Opcoes = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: darkMode ? "#EDEDED" : "#525252",
          boxWidth: 15,
        },
        margin: {
          top: 5,
        },
      },
      title: {
        display: true,
        text: `${numeroCalendario}`,
        font: {
          size: 14,
          weight: "bold",
        },
        color: darkMode ? "#EDEDED" : "#525252",
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 24,
          color: darkMode ? "#EDEDED" : "#525252",
        },
        grid: {
          color: darkMode ? "#bebebe81" : "#52525232",
        },
      },
      y: {
        min: 0,
        max: altura,
        ticks: {
          color: darkMode ? "#EDEDED" : "#525252",
        },
        grid: {
          color: darkMode ? "#bebebe81" : "#52525232",
        },
      },
    },
  };

  useEffect(() => {
    const novaDataCalendario = dataPoco.filter((id) => id.id_poco === idPoco);
    if (novaDataCalendario.length >= 1) {
      renderData(novaDataCalendario[0].data);
    }
  }, [dataPoco, selectedDate]);

  useEffect(() => {
    if (socket) {
      if (pocoCalender !== "") {
        socket.on("creat_newHistorico", () => {
          renderData(pocoCalender);
        });
      } else {
        socket.on("creat_newHistorico", () => {
          renderData(selectedDate);
        });
      }
    }
  }, [socket]);

  return (
    <GraficoPocoStyled darkmode={darkMode}>
      <div className="TitleContainer">
        <CiCalendar
          className="CiCalendar"
          onClick={() => {
            setModalIsOpen(!modalIsOpen);
            setIdDataPoco(idPoco);
          }}
        />
        <span className="DateText">{numeroCalendario.split(" ")[0]}</span>
      </div>
      <Bar data={Dados} options={Opcoes} />
    </GraficoPocoStyled>
  );
};

export const GraficoBomba = (props) => {
  const { idBomba } = props;
  const {
    modalIsOpenBomba,
    setModalIsOpenBomba,
    selectedDateBomba,
    fetchDadosBomba,
    idDataBomba,
    setIdDataBomba,
    setDataBomba,
    dataBomba,
  } = useContext(ElevatoriaContext);

  const [listaGrafico, setListaGrafico] = useState([]);
  const [dataCalendario, setDataCalendario] = useState(selectedDateBomba);
  const [numeroCalendario, setNumeroCalendario] = useState("");

  const ListarData = (data) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const response = data.toLocaleDateString("pt-BR", options);
    setNumeroCalendario(response);
  };

  const getCurrentDate = () => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return dataCalendario.toLocaleDateString("pt-BR", options);
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm:ss");
  };

  const renderData = async (data) => {
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");

    const token = localStorage.getItem("tokenBrk");

    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      ListarData(data);
      const response = await apiSae.get(
        `/historico/Bomba/data/${idBomba}/${day}-${month}-${year}`,
        headerApi
      );
      setListaGrafico(response.data);
    } catch (error) {
      setListaGrafico([]);
    }
  };

  useEffect(() => {
    renderData(selectedDateBomba);
  }, [idBomba]);

  const Dados = {
    labels: listaGrafico.map((label) => formatTime(label.timestamp)),
    datasets: [
      {
        label: "Tensão",
        data: listaGrafico.map(
          (label) => label.tensaoR + label.tensaoS + label.tensaoT / 3
        ),
        backgroundColor: "#EF989B",
        borderColor: "#EF989B",
        borderWidth: 1,
        tension: 0.3,
      },
      {
        label: "Corrente",
        data: listaGrafico.map((label) => label.corrente),
        backgroundColor: "#86755C",
        borderColor: "#86755C",
        borderWidth: 1,
        tension: 0.3,
      },
      {
        label: "RPM",
        data: listaGrafico.map((label) => label.rpm),
        backgroundColor: "#8448FB",
        borderColor: "#8448FB",
        borderWidth: 1,
        tension: 0.3,
      },
      {
        label: `Frequência`,
        data: listaGrafico.map((label) => label.frequencia),
        backgroundColor: "#16841B",
        borderColor: "#16841B",
        borderWidth: 1,
        tension: 0.3,
      },
    ],
  };

  const Opcoes = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          boxWidth: 20,
        },
        margin: {
          top: 2,
        },
      },
      title: {
        display: true,
        text: `${numeroCalendario}`,
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    scales: {
      y: {
        min: 0,
      },
    },
  };

  useEffect(() => {
    const novaDataCalendario = dataBomba.filter(
      (id) => id.id_bomba === idBomba
    );
    if (novaDataCalendario.length >= 1) {
      setDataCalendario(dataBomba[0].data);
      renderData(novaDataCalendario[0].data);
    }
  }, [dataBomba]);

  /*useEffect(() => {
    if () {
      document.body.classList.add("modal-open"); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove("modal-open"); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);*/

  return (
    <CalendarioBombaStyled>
      <Line data={Dados} options={Opcoes} />
      <div className="TitleContainer">
        <CiCalendar
          className="CiCalendar"
          onClick={() => {
            setModalIsOpenBomba(!modalIsOpenBomba);
            setIdDataBomba(idBomba);
          }}
        />
        <span className="DateText">{numeroCalendario.split(" ")[0]}</span>
      </div>
    </CalendarioBombaStyled>
  );
};

export const ModalGraficoPoco = () => {
  const {
    setModalIsOpen,
    selectedDate,
    setSelectedDate,
    idDataPoco,
    setDataPoco,
    dataPoco,
  } = useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);

  const closeModal = () => setModalIsOpen(false);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState("dia");

  const handleDateChange = (date) => {
    setSelectedDate(date);

    setDataPoco((prevDataPoco) => {
      const index = prevDataPoco.findIndex(
        (item) => item.id_poco === idDataPoco
      );

      if (index !== -1) {
        const updatedDataPoco = [...prevDataPoco];
        updatedDataPoco[index] = { ...updatedDataPoco[index], data: date };
        return updatedDataPoco;
      } else {
        return [...prevDataPoco, { id_poco: idDataPoco, data: date }];
      }
    });

    closeModal();
  };

  const generateReport = async (formatType) => {
    const tableColumn = ["Data", "Hora", "Nivel"];

    const dataFormatada =
      dataPoco && dataPoco[0]?.data
        ? format(new Date(dataPoco[0].data), "dd-MM-yyyy")
        : format(new Date(), "dd-MM-yyyy");

    const relatorioTotal = await apiSae.get(
      `historico/poco/data/${idDataPoco}/${dataFormatada}/${opcaoSelecionada}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .reverse()
      .map((item) => [
        format(new Date(item.timestamp), "yyyy-MM-dd"),
        format(new Date(item.timestamp), "HH:mm"),
        item.nivel_atual,
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(`Relatório_de_NIvel.${format(new Date(), "yyyy-MM-dd")}.pdf`);
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_NIvel${format(new Date(), "yyyy-MM-dd")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <ModalCalenderPoco>
      <div className="conteiner">
        <h2>Selecionar Data</h2>
        <DatePicker
          className="agenda"
          selected={selectedDate}
          onChange={handleDateChange}
          inline
        />
        <button className="botaoFechaAgenda" onClick={closeModal}>
          x
        </button>
        <div className="selectRelatorio">
          <label>Período do histórico: </label>
          <select
          // value={opcaoSelecionada} onChange={handleChange}
          >
            <option value="dia">Dia</option>
            <option value="mes">Mês</option>
            <option value="ano">Ano</option>
          </select>
        </div>
        <div className="buttonsRelatorio">
          <button
            onClick={() => {
              generateReport("csv");
            }}
          >
            Download CSV
          </button>
          <button
            onClick={() => {
              generateReport("pdf");
            }}
          >
            Download PDF
          </button>
        </div>
      </div>
    </ModalCalenderPoco>
  );
};

export const ModalGraficoBomba = () => {
  const {
    setModalIsOpenBomba,
    selectedDateBomba,
    setSelectedDateBomba,
    idDataBomba,
    setDataBomba,
  } = useContext(ElevatoriaContext);

  const closeModalBomba = () => setModalIsOpenBomba(false);

  const handleDateChange = (date) => {
    setSelectedDateBomba(date);

    setDataBomba((prevDataBomba) => {
      const index = prevDataBomba.findIndex(
        (item) => item.id_bomba === idDataBomba
      );

      if (index !== -1) {
        const updatedDataBomba = [...prevDataBomba];
        updatedDataBomba[index] = { ...updatedDataBomba[index], data: date };
        return updatedDataBomba;
      } else {
        return [...prevDataBomba, { id_bomba: idDataBomba, data: date }];
      }
    });

    closeModalBomba();
  };

  return (
    <ModalCalenderBomba>
      <div className="conteiner">
        <h2>Selecionar Data</h2>
        <DatePicker
          className="agenda"
          selected={selectedDateBomba}
          onChange={handleDateChange}
          inline
        />
        <button className="botaoFechaAgenda" onClick={closeModalBomba}>
          Fechar
        </button>
      </div>
    </ModalCalenderBomba>
  );
};
